import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import StockItemsForm from "../../../../components/ClientSettings/StockManager/StockItems/StockItemsForm";
import { connect, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  addStockItemAction,
  checkUniqueSkuNumberAction,
  getAllTypesParentStockGroupAction,
  getAllUnitMeasurementListAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetSingleStockItemData,
  resetStockItemList,
} from "../../../../redux/clientSettings";
import {
  AddStockItemPayloadType,
  CheckUniqueSkuNumberPayloadType,
  getAllTypesParentStockGroupType,
  GetAllUnitMeasurementListPayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import {
  AllGroupStockListType,
  AllUnitsMeasurementListType,
  StockItemDetailsType,
} from "../../../../redux/clientSettings/clientSettingTypes";
import  { Toaster } from "react-hot-toast";
import { resetSession } from "../../../../redux/auth";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import { GetPathBeforeClientCode } from "../../../../components/commons/UserManagement";

type AppProps = {
  history?: any;
  fetching: boolean;
  uniqueSkuFetching?: boolean;
  success: number | null;
  token: string | null;
  error: string | null;
  skuMessage: string | null;
  statusCode: number | null;
  allUnitsMeasurement?: [] | AllUnitsMeasurementListType[];
  groupStockList?: [] | AllGroupStockListType[];
  allStockItemList?: [] | any[];
  singleStockItemData: StockItemDetailsType[];
  dispatchGetAllUnitMeasurementListAction: (
    data: GetAllUnitMeasurementListPayloadType
  ) => void;
  dispatchAddStockItemAction: (data: AddStockItemPayloadType) => void;
  dispatchGetListStockGroup: (data: any) => void;
  dispatchResetStockItemList: () => void;
  dispatchResetSession: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetSingleStockData: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchCheckUniqueSkuNumberAction: (
    data: CheckUniqueSkuNumberPayloadType
  ) => void;
};

const AddStockItem = ({
  history,
  fetching,
  success,
  error,
  statusCode,
  skuMessage,
  uniqueSkuFetching,
  allUnitsMeasurement,
  groupStockList,
  allStockItemList,
  singleStockItemData,
  dispatchGetAllUnitMeasurementListAction,
  dispatchGetListStockGroup,
  dispatchAddStockItemAction,
  dispatchResetStockItemList,
  dispatchResetSession,
  dispatchResetClientSettingsError,
  dispatchResetSingleStockData,
  dispatchResetClientSettingsSuccessAction,
  dispatchCheckUniqueSkuNumberAction,
}: AppProps) => {
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const token = useSelector((state: RootState) => state.auth.token);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [finalStockGroupList, setFinalStockGroupList] = useState<any>([]);
  const [isAddStockItemUrlPresent, setIsAddStockItemUrlPresent] =
    useMenuCheck();

  const url = history?.location?.pathname;
  useEffect(() => {
    dispatchResetSingleStockData();
    setIsAddStockItemUrlPresent(GetPathBeforeClientCode(url), "url");
    if (client_code && token) {
      let finalData = {
        token,
        client_code,
      };
      dispatchGetAllUnitMeasurementListAction(finalData);
      dispatchGetListStockGroup(finalData);
    }
     //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isAddStockItemUrlPresent === false) {
      history.push("/access-denied");
    }
     //eslint-disable-next-line
  }, [isAddStockItemUrlPresent]);

  useEffect(() => {
    handleManipulateStockGroupListData(groupStockList);
  }, [groupStockList]);

  // Recussively manipulating stock group data to populate in dropdown
  const handleManipulateStockGroupListData = (
    stockGroupData: any,
    finalStockData: any = []
  ) => {
    let count = 0;
    function getAllData(arr: any) {
      arr.map((e: any, i: number) => {
        if (count > 0) {
          finalStockData.push({
            stock_group_name: e?.stock_group_name,
            stock_group_id: e?.stock_group_id,
            count,
          });
        } else {
          finalStockData.push({
            stock_group_name: e?.stock_group_name,
            stock_group_id: e?.stock_group_id,
          });
        }
        if (e.is_tree == 1) {
          count++;
          getAllData(e.tree_data);
          count--;
        }
      });
    }

    getAllData(stockGroupData);
    setFinalStockGroupList(finalStockData);
  };

  const uniqueSkuNumberCheck = (data: CheckUniqueSkuNumberPayloadType) => {
    if (client_code && token) {
      dispatchCheckUniqueSkuNumberAction(data);
    }
  };

  const handleSubmitStockItemData = (data: AddStockItemPayloadType) => {
    if (client_code && token) {
      dispatchAddStockItemAction(data);
      handleSuccessMessag("create_stock");
      dispatchResetStockItemList();
    }
  };

  const handleSuccessMessag = (type: string) => {
    switch (type) {
      case "update_stock":
        return setSuccessMessage("Stock Item Details Updated Successfully!");
      case "create_stock":
        return setSuccessMessage("Stock Added Successfully!");
      default:
        return setSuccessMessage("Document Created Successfully!");
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Stock Item Added Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetClientSettingsSuccessAction();
            history.goBack();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  return (
    <>
      <CommonHeader
        title="Add Stock Item"
        company_name={company_name}
        client_code={client_code}
      />
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="content-area">
            <StockItemsForm
              history={history}
              singleStockItemData={singleStockItemData}
              allUnitsMeasurement={allUnitsMeasurement}
              groupStockList={finalStockGroupList}
              handleSubmitStockItemData={handleSubmitStockItemData}
              token={token}
              client_code={client_code}
              allStockItemList={allStockItemList}
              uniqueSkuNumberCheck={uniqueSkuNumberCheck}
              skuMessage={skuMessage}
              uniqueSkuFetching={uniqueSkuFetching}
            />
            {fetching && <Loader />}
            {handleErrorModal()}
            <Toaster />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateTopProps = (state: RootState) => ({
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  skuMessage: state.clientSettings.skuMessage,
  uniqueSkuFetching: state.clientSettings.uniqueSkuFetching,
  allUnitsMeasurement: state.clientSettings.allUnitsMeasurement,
  groupStockList: state.clientSettings.groupParentStockList,
  allStockItemList: state.clientSettings.allStockItemList,
  singleStockItemData: state.clientSettings.singleStockItemData
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllUnitMeasurementListAction: (
    data: GetAllUnitMeasurementListPayloadType
  ) => dispatch(getAllUnitMeasurementListAction(data)),

  dispatchGetListStockGroup: (data: getAllTypesParentStockGroupType) =>
    dispatch(getAllTypesParentStockGroupAction(data)),

  dispatchAddStockItemAction: (data: AddStockItemPayloadType) =>
    dispatch(addStockItemAction(data)),

  dispatchResetStockItemList: () => dispatch(resetStockItemList()),
  dispatchResetSession: () => dispatch(resetSession()),

  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () =>
    dispatch(resetClientSettingsSuccess()),

  dispatchCheckUniqueSkuNumberAction: (data: CheckUniqueSkuNumberPayloadType) =>
    dispatch(checkUniqueSkuNumberAction(data)),
    dispatchResetSingleStockData:()=>dispatch(resetSingleStockItemData())
});

export default connect(mapStateTopProps, mapDispatchToProps)(AddStockItem);
